import React, { useState } from 'react';
import { View, Text } from 'react-native';
import moment from 'moment';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';
import DateInput from 'app/src/elements/DateInput';

const ReversedEntryReports = () => {
  const [startOn, setStartOn] = useState(
    moment().subtract({ months: 1 }).startOf('month').format('YYYY-MM-DD')
  );

  const [endOn, setEndOn] = useState(
    moment().subtract({ months: 1 }).endOf('month').format('YYYY-MM-DD')
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'reversed-entry-report',
      params: { 'start-on': startOn, 'end-on': endOn }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Reversed Entry Report</Text>
      <Text style={styles.label}>Start On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
      />
      <Text style={styles.label}>End On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
}

export default ReversedEntryReports;
